import type { CmmdTaskWorkflow } from "@cmmd-forge/contracts";

type WorkflowStage = CmmdTaskWorkflow["stages"][number];

export interface ProjectTaskWorkflowStageSelectProps {
  readonly ariaLabel: string;
  readonly stages: readonly WorkflowStage[];
  readonly value: string;
  readonly onChange: (id: string) => void;
}

export function ProjectTaskWorkflowStageSelect(props: ProjectTaskWorkflowStageSelectProps) {
  return (
    <select
      aria-label={props.ariaLabel}
      className="h-8 min-w-0 flex-1 rounded-md border border-input bg-background px-2 text-xs"
      value={props.value}
      onChange={(event) => props.onChange(event.target.value)}
    >
      {props.stages.map((stage) => (
        <option key={stage.id} value={stage.id}>
          {stage.name}
        </option>
      ))}
    </select>
  );
}
